let GetPhotoSummary = function (photo) {
  var summary = {
    name: photo.filename || '(No Name)',
    tags: photo.tags || null
  };
  if (photo.synced_time != null) {
    summary['.priority'] = photo.synced_time;
  } else {
    summary['.priority'] = '' + photo.camera_model + photo.date_taken;
  }
  if (photo.associated_locations != null) {
    summary.associated = true;
  }
  if (photo.status != 'upload_complete' && photo.status != null) {
    summary.status = photo.status;
  }
  if (photo.camera_id != null) {
    summary.camera_id = photo.camera_id;
  }
  var photoData = photo.photofirst_data;
  if (photoData != null) {
    for (var key in photoData) {
      if (key[0] != '_') {
        summary.data = true;
        break;
      }
    }
    if ((photoData.poleHeight || photoData.midspanHeight) && !photoData.rubbish) summary.height = true;
    if (photoData.sync) summary.sync = true;
    if (photoData.job) {
      summary.job = true;
      let tag = Object.values(photoData.job)[0];
      if (tag) summary.job_id = tag.jobname || null;
    }
    if (photoData.cableTag) summary.cable_tag = true;
  }
  return summary;
};
let AreSummariesEqual = function (summary1, summary2) {
  if ((summary1 == null || summary2 == null) && summary1 != summary2) {
    return false;
  }
  for (var key in summary1) {
    if (key[0] != '.' && key[0] != '_') {
      if (summary1[key] != summary2[key]) {
        return false;
      }
    }
  }
  for (var key in summary2) {
    if (key[0] != '.' && key[0] != '_') {
      if (summary2[key] != summary1[key]) {
        return false;
      }
    }
  }
  return true;
};

export { GetPhotoSummary, AreSummariesEqual };
